import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import './less/StartingBanner.less';
import { Button, Modal, Form, Input } from 'antd';

function StartingBanner(props) {

    const [isModalVisible, setIsModalVisible] = React.useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const validateMessages = {
        required: '${label} را وارد کنید!',
    };

    return (
        <div {...props}>
            <div className="home-page starting-banner">
                <h4>مدتاک، همراه شما برای برای ساخت آینده ای بهتر</h4>
                <p>چطور شروع کنم ؟</p>
                <div style={{ marginTop: 20, textAlign: 'center' }}>
                    <div className="actions-box" style={{ marginTop: 20 }}>
                        <Button onClick={showModal} className="ant-btn bold-btn">
                        درخواست مشاوره
                        </Button>
                        {/* <Link href="/online-class/plans" to="/online-class/plans" className="ant-btn bold-btn">
                            ثبت سفارش
                        </Link> */}
                        {/* <Link href="/online-class/plans" to="/online-class/plans" className="my-link">
                            درخواست مشاوره<LeftOutlined />
                        </Link> */}
                    </div>
                </div>
            </div>

            <Modal title="وارد کردن اطلاعات" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <div>
                    اطلاعات خود را وارد کنید تا همکاران ما برای راهنمایی بیشتر در اسرع وقت با شما تما بگیرند.
          </div>

                <div className="ant-row ant-row-rtl" style={{ marginTop: 20 }}>
                    <div className="ant-col ant-col-xs-24 ant-col-rtl14">
                        <Form {...layout} name="nest-messages" validateMessages={validateMessages}>
                            <Form.Item name={['user', 'name']} label="نام و نام خانوادگی" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>

                            <Form.Item name={['user', 'phone']} label="شماره تماس" rules={[{ required: true, min: 0, max: 11 }]}>
                                <Input />
                            </Form.Item>
                        </Form>
                    </div>
                </div>

            </Modal>


        </div>
    )
}

export default StartingBanner;